<p translate="error-renderer-invalid-activity-type-main-message"></p>

<a
	href="{{contactSupport}}"
	target="_blank"
	class="tertiary-btn stacked-item"
	translate="error-renderer-contact-support">
</a>
